export default function FormDeleted() {
  return <div>Ihr Formular wurde erfolgreich verarbeitet.</div>;
}
